import { render } from "./menu.vue?vue&type=template&id=c08e4260&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=c08e4260&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c08e4260"

export default script